import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// quill 富文本编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import '@/assets/styles/iconfont/iconfont.css'

//图片预览插件
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer';

require('./jslibs/verify-code.min');

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Viewer);

window.vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
